import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import {discount,discountPercent} from '../../Helper'
const state = {
    listings:[],
    items:[],
    listing : [],
    index:'',
    sortBy:'',
    sortDesc:''



};

const getters = {
    getListings: state => {
        return state.listings;
    },
    getItems: state => {
        return state.items;
    },
    getListing: state => {
        return state.listing;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },



};

const actions = {
    setUpdateStatusItem : async (context,payload) =>{
        //console.log("parent",payload)
        //console.log(payload)
        let url = "listings/items/update/status";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setCategories', res.data.data);
                return {data:res.data,level:payload.level}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    setChangeValueListing : async (context,payload) =>{
        //console.log("parent",payload)

        let url = "listings/items/update/price";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                context.commit('setListing', res.data.data);
                return {data:res.data,level:payload.level}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    setChangeValueListingUser : async (context,payload) =>{
        //console.log("parent",payload)

        let url = "listings/items/update/price/user";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                context.commit('setListing', res.data.data);
                return {data:res.data,level:payload.level}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    addItemsToListing : async (context,payload) =>{


        let url = "listings/items/add";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                context.commit('setListing', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    asyncFetchItems : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "listings/items";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['listings/getSortBy'],
                    'sortDesc': context.rootGetters['listings/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                var settings = context.rootGetters['listings/getListing'];
                var user = context.rootGetters['customers/getItem'];

                var items = res.data.data
                _.forEach(items,async(item) =>{
                    var check = _.find(settings.rules,{_id:item._id,id:item.variants.uuid})
                    if(!check) {
                        var prices = await discount(item.variants.sell, item.variants.pricevat, item.vat.vat, settings.percent);
                        _.assignIn(item.variants, {
                            originSell: +item.variants.sell,
                            originPricevat: +item.variants.pricevat
                        })
                        item.variants.sell = +prices.discountPrice
                        item.variants.pricevat = +prices.discountPriceVat
                        var dicountPercentValue = await discountPercent(item.variants.originSell, item.variants.sell)
                        _.assignIn(item.variants, {discount: +dicountPercentValue})
                    }else{
                        _.assignIn(item.variants, {
                            originSell: +item.variants.sell,
                            originPricevat: +item.variants.pricevat,
                            discount:check.discount
                        })
                        item.variants.sell = check.price
                        item.variants.pricevat = check.pricevat

                    }
                    // verifichiamo se ci sono regole per utente
                    var checkUser = _.find(settings.users,{_id:item._id,id:item.variants.uuid,id_user:user._id})
                    if(checkUser){
                        item.variants.sell = checkUser.price
                        item.variants.pricevat = checkUser.pricevat
                        item.variants.discount = checkUser.discount

                    }


                    if(_.find(settings.items,{id:item.variants.uuid})){
                        //item = {statusRules:true,...item}
                        _.assignIn(item,{statusRules:true})
                    }else{
                        //item = {statusRules:false,...item}
                        _.assignIn(item,{statusRules:false})
                    }
                    _.assignIn(item,{indice:`${item._id}#${item.variants.uuid}`})
                })
                context.commit('setItems', items);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "listings";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['listings/getSortBy'],
                    'sortDesc': context.rootGetters['listings/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);
                context.commit('setListings', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    setUpdateStatusListing : async (context,payload) =>{
        //console.log("parent",payload)
        //console.log(payload)
        let url = "listings/update/status";
        return await   axios.put(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': payload
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setCategories', res.data.data);
                return {data:res.data,level:payload.level}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },

    deleteListings : async (context,settings) => {


        let url = "listings/delete";


        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )

            .then(res => {
                return res.data
            })
            .catch(err => {
                console.log("errore", err.response.status);
                return {error:err.response.status}

            });

    },

    getDetailListing : async (context,payload) =>{
        //console.log(payload)
        let url = `listings/detail/${payload}`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                context.commit('setListing', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
              /*  if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    getListings : async (context,payload) =>{
        //console.log(payload)
        let url = `listings/list`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);

                return {data:res.data.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*  if (err.response.status === 401) {

                      //this.setLogout();
                      context.commit('profile/setLogout', {}, {root: true})
                      this.$router.push('/login')
                  }
                  throw Error(err.response.status + ":Posts Not Found");*/
            });
    },



    destroyData : (context) =>{
        context.commit('setListings',[]);
        context.commit('setListing',[]);
        context.commit('setItems',[]);



    },


};

const mutations = {
    setListings: (state,value) => {
        state.listings= value;
    },
    setItems: (state,value) => {
        state.items= value;
    },
    setListing: (state,value) => {
        state.listing= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    }



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
